import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../lib/auth';
import { Auth } from '../lib/api';

export function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    try {
      await login(password);
      nav('/', { replace: true });
    } catch (err) {
      const msg = err instanceof Error ? err.message : 'Erro de autenticação';
      setError(msg === 'Senha incorreta' ? 'Senha incorreta' : `Falha: ${msg}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid place-items-center p-6 relative overflow-hidden">
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute -top-40 -left-40 w-[480px] h-[480px] rounded-full bg-accent/10 blur-3xl" />
        <div className="absolute -bottom-32 -right-32 w-[420px] h-[420px] rounded-full bg-info/10 blur-3xl" />
      </div>
      <form onSubmit={handleSubmit} className="card w-full max-w-sm p-8 animate-fadeIn relative">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-11 h-11 rounded-xl bg-gradient-to-br from-accent to-info shadow-lg shadow-accent/30 grid place-items-center font-bold text-bg text-xl">F</div>
          <div>
            <div className="text-xl font-bold tracking-tight text-white">FreeBuff</div>
            <div className="text-xs text-slate-400">Painel de monitoramento VPS</div>
          </div>
        </div>
        <h2 className="text-lg font-semibold mb-1">Entrar</h2>
        <p className="text-sm text-slate-400 mb-6">Use a senha definida em <code className="font-mono text-slate-300">DASHBOARD_PASSWORD</code> no <code className="font-mono text-slate-300">.env</code>.</p>
        <label className="label">Senha</label>
        <input
          autoFocus
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="input"
          placeholder="••••••••"
        />
        {error && <div className="mt-3 text-sm text-danger">{error}</div>}
        <button type="submit" disabled={loading || !password} className="btn btn-primary w-full justify-center mt-5">
          {loading ? 'Verificando…' : 'Entrar'}
        </button>
        <div className="mt-6 pt-5 border-t border-border text-xs text-slate-500 text-center">
          <button
            type="button"
            className="hover:text-slate-300"
            onClick={() => Auth.me().then(() => null).catch(() => null)}
          >
            Esqueceu? Reinicie o servidor com <code className="font-mono">DASHBOARD_PASSWORD</code> alterado.
          </button>
        </div>
      </form>
    </div>
  );
}
